export const deSelectedServices = ["lfsm"];

export const eightWeeksInMilliseconds = 838400000;

export const thirtyMins = 1000 * 60 * 30;

//controls how far the points have to be (in milliseconds) on x-axis to share a tooltip
export const millisecondBufferToShareTooltip = 2;

export const CURRENT_TIME = "current-time";

export const excludedStates: ("rejected" | "deleted")[] = [
  "rejected",
  "deleted",
];
